import {globalMessageHandler, useDialog, useGrid, UseGridReturnType} from "common";
import {
  getOpenapiKeyService,
  OpenapiKeyFormItem,
  OpenapiKeyListItem,
} from "./openapiKeyApi";
import I18n from "i18n-js";
import api from "../../app/api";

export type UseOpenapiListReturnType = {
  connectItemDialog: any;
  editItemDialog: any;
  connectItem?: OpenapiKeyListItem;
  editItem?: OpenapiKeyListItem;
  setConnectItem: Function;
  setEditItem: Function;
  renew: (id: number) => void;
} & UseGridReturnType;

export default function useOpenapiKeyList(): UseOpenapiListReturnType {
  const service = getOpenapiKeyService();
  const list = useGrid<OpenapiKeyFormItem, OpenapiKeyListItem>({
    comaSeparatedSortPrarms: true,
    storageType: "urlParams",
    id: "OpenapiKeys",
    loadColumns: true,
    translationCategory: "OpenapiKey",
    confirmAttribute: "name",
    exportFilter: filter => ({
      ClientSearch: filter,
    }),
    ...service,
    loadOptions: undefined,
  });

  const [connectItem, setConnectItem, connectItemDialog] = useDialog();
  const [editItem, setEditItem, editItemDialog] = useDialog();

  const renew = (id: number) => {
    globalMessageHandler.confirm(I18n.t("OpenapiKey.renewConfirm"), async () => {
      const response = await api.get(`/openapi-keys/renew?id=${id}`);

      if (response.success && response.data.success && response.data.data.key) {
        globalMessageHandler.infoModal(I18n.t("OpenapiKey.apiKeyMessage", {key: response.data.data.key}));
      } else {
        globalMessageHandler.error(I18n.t("OpenapiKey.renewError"));
      }
    });
  };

  return {
    ...list,
    connectItemDialog,
    editItemDialog,
    connectItem,
    editItem,
    setConnectItem,
    setEditItem,
    renew,
  };
}
